import { ComparePreset } from './datePicker/types';
import { t } from '../i18n';

// null cuando no hay base con la que comparar (periodo anterior a 0 o sin
// dato): la variación no está definida y no se muestra, en vez de ∞%.
const getDiff = (value: number, previousValue: number): number | null => {
  if(!previousValue || !Number.isFinite(previousValue) || !Number.isFinite(value)) {
    return null;
  }
  return Math.round(((value - previousValue) / Math.abs(previousValue)) * 100);
}

// Etiqueta junto al badge de Diff, en vez del "than last period" fijo de
// antes. 'custom' no tiene una regla nombrable, así que cae en el mismo
// texto genérico que 'prev-period'.
const getComparePresetLabel = (comparePreset?: ComparePreset): string => {
  return t(`compare.${comparePreset || 'prev-period'}`);
}

export { getDiff, getComparePresetLabel };